import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'apps/driver-dashboardfe/src/environments/environment';

export interface OrderTrackingResponse {
    data: OrderTrackingData;
    message: string;
    success: boolean;
    is_cache: boolean;
}

export interface TrackingEventRaw {
    eventCity: string;
    eventState: string;
    eventTimestamp: string;
    eventType: string;
    eventZIPCode: string;
    eventCode?: string;
    eventCountry?: string;
    GMTTimestamp?: string;
    GMTOffset?: string;
    veriPoint?: boolean;
    recipientName?: string;
    acceptanceTypeCategory?: string;
    acceptanceTypeCategoryCode?: string;
    actionCode?: string | null;
    CODAmountDue?: string | null;
    eventPartner?: string | null;
    firm?: string | null;
    reasonCode?: string | null;
}

export interface OrderItem {
    name?: string;
    item_name?: string;
    quantity: number;
    image_url?: string;
}

export interface OrderTrackingData {
    origin: { address: string; shipped_at?: string };
    current_location: { address: string; event: string; updated_at: string };
    estimated_delivery: string;
    destination: { address: string };
    status: string;
    status_summary: string;
    tracking_events: TrackingEventRaw[];
    order_number?: string;
    tracking_number?: string;
    shipping_platform?: string;
    tracking_url?: string;
    items?: OrderItem[];
    line_items?: OrderItem[];
    recipient_name?: string;
}

export interface TimelineDisplayItem {
    label: string;
    date: string;
    location: string;
    is_completed: boolean;
    is_current: boolean;
    is_estimated?: boolean;
    recipientName?: string;
}

@Injectable({
    providedIn: 'root',
})
export class OrderTrackingService {
    constructor(private http: HttpClient) {}

    getOrderTracking(token: string): Observable<OrderTrackingData> {
        return this.http
            .post<OrderTrackingResponse>(
                `${environment.baseURL}driver/shipment-tracking/`,
                { token }
            )
            .pipe(map((res) => res?.data ?? (res as any)));
    }
}
